import React, { useState } from "react";

const ContainerTemperatureModal = ({ onClose, onSave, initialValue = "" }) => {
    const [value, setValue] = useState(initialValue !== null && initialValue !== undefined ? String(initialValue) : "");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [error, setError] = useState("");

    const handleConfirm = async () => {
        if (isSubmitting) return;

        const trimmed = value.trim();
        if (trimmed !== "" && isNaN(Number(trimmed))) {
            setError("Please enter a valid temperature.");
            return;
        }

        setError("");
        setIsSubmitting(true);
        try {
            await onSave(trimmed === "" ? null : Number(trimmed));
            onClose();
        } catch (err) {
            console.error("Container Temperature save failed:", err);
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-custom-bg-purple bg-opacity-50 dark:bg-black/70 px-4">
            <div className="bg-white dark:bg-acs-dark-surface rounded-xl shadow w-full max-w-md p-fluid-3 space-y-fluid-3 border border-gray-200 dark:border-acs-dark-border animate-slide-in">
                <div className="flex justify-between items-center border-b border-gray-300 dark:border-acs-dark-border pb-fluid-2">
                    <h3 className="text-fluid-lg font-semibold text-gray-900 dark:text-acs-dark-text">
                        Edit Container Temperature
                    </h3>
                    <button
                        onClick={onClose}
                        className="text-gray-500 dark:text-acs-dark-subtext hover:text-gray-900 dark:hover:text-white text-fluid-xl transition-colors"
                    >
                        ✕
                    </button>
                </div>

                <div>
                    <label className="block text-fluid-sm font-medium text-gray-700 dark:text-acs-dark-text mb-1">
                        Container Temperature (degree F)
                    </label>
                    <input
                        type="number"
                        step="0.01"
                        value={value}
                        onChange={(e) => {
                            setValue(e.target.value);
                            if (error) setError("");
                        }}
                        placeholder="Enter temperature in °F"
                        className="w-full border border-gray-300 dark:border-acs-dark-border rounded px-fluid-input-x py-fluid-input-y text-fluid-base bg-white dark:bg-acs-dark-surface text-gray-900 dark:text-acs-dark-text focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-[#3B5CCC] transition-colors"
                        disabled={isSubmitting}
                        autoFocus
                    />
                    {error && (
                        <p className="text-red-500 text-fluid-xs mt-1">{error}</p>
                    )}
                </div>

                <div className="flex justify-end gap-fluid-2 pt-fluid-2 border-t border-gray-200 dark:border-acs-dark-border">
                    <button
                        onClick={onClose}
                        className="px-fluid-button-x py-fluid-button-y border border-gray-300 dark:border-[#3B5CCC] text-gray-700 dark:text-acs-dark-text rounded transition-colors hover:bg-gray-100 dark:hover:bg-acs-dark-hover text-fluid-sm disabled:opacity-50 disabled:cursor-not-allowed"
                        disabled={isSubmitting}
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleConfirm}
                        disabled={isSubmitting}
                        className={`px-fluid-button-x py-fluid-button-y text-white text-fluid-sm rounded font-semibold transition ${
                            isSubmitting
                                ? "bg-blue-300 dark:bg-blue-900 cursor-not-allowed"
                                : "bg-blue-600 dark:bg-[#3B5CCC] hover:bg-blue-700 dark:hover:bg-[#4C6EE7]"
                        }`}
                    >
                        {isSubmitting ? "Saving..." : "Update"}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ContainerTemperatureModal;
